var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOrder = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 176.82 176.25"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Order_svg__cls-1,.Order_svg__cls-2{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:11.25px}.Order_svg__cls-1{stroke-linecap:square}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Order_svg__Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Order_svg___\\xCE\\xD3\\xC8_1",
  "data-name": "\\u2014\\xCE\\xD3\\xC8_1"
}, /*#__PURE__*/React.createElement("circle", {
  className: "Order_svg__cls-1",
  cx: 43.12,
  cy: 155.63,
  r: 15
}), /*#__PURE__*/React.createElement("circle", {
  className: "Order_svg__cls-1",
  cx: 148.12,
  cy: 155.63,
  r: 15
}), /*#__PURE__*/React.createElement("path", {
  className: "Order_svg__cls-2",
  d: "M148.12 140.63h-105M31.45 35.63l139.16 14.99-6.67 60.01H39.79"
}), /*#__PURE__*/React.createElement("path", {
  className: "Order_svg__cls-1",
  d: "m43.12 140.63-14.99-135H5.63"
})))));
export default SvgOrder;